import { Badge, FlexAligner } from '@scaleaq/scaleui';
import { GensetInfo, GensetMode } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { Content } from '@/components/cardWithThreeFooterBox';
import { GeneratorStatistics } from '@/components/generators/generator/GeneratorStatistics.tsx';
import { getBadgeType } from '@/components/generators/generator/helpFunctions.ts';
import { GridWidget } from '@/components/GridWidget.tsx';
import { GenericWidgetProps } from '@/types.ts';

import { GeneratorState } from './generator/GeneratorState.tsx';

export const Generator = ({
  generator,
  ...rest
}: { generator: GensetInfo } & GenericWidgetProps) => {
  const { t } = useTranslation(['hybridPower']);

  return (
    <GridWidget
      {...rest}
      status={generator.status}
      headerTitle={generator.name}
      style={{ minHeight: '14.5rem' }}
    >
      <Content>
        <FlexAligner direction='column' spaceBetween fullHeight>
          <Badge
            label={t(
              `hybridPower:generator.generatorMode.${generator.mode.toString() as GensetMode}`
            )}
            type={getBadgeType(generator.mode)}
          />
          <GeneratorState state={generator.state} powerP={generator.powerP} />
        </FlexAligner>
        <GeneratorStatistics generator={generator} />
      </Content>
    </GridWidget>
  );
};
